import storageInstance from 'store2';
import { SessionData, SessionMetadata } from '@/store';

export interface ISessionService {
  setPersistance(persist: boolean): void;
  getSessionData(): SessionData;
  renewSession(data: SessionData): void;
  clearSession(): void;
  sessionExpired(): boolean;
  getSessionTime(): number;
}

export class SessionService implements ISessionService {
  private persist: boolean = true;
  private store: any;

  constructor(vuexStore: any) {
    this.store = vuexStore;
    const storedData: any = storageInstance.local.get('sessionData') || storageInstance.session.get('sessionData');
    if (storedData?.version === SessionMetadata.VERSION) {
      this.store.commit('setSessionData', storedData);
    }
  }

  public setPersistance(persist: boolean): void {
    this.persist = persist;
    if (!persist) {
      storageInstance.local.remove('sessionData');
      storageInstance.session.remove('sessionData');
    }
  }

  public renewSession(data: SessionData): void {
    const newSessionData: SessionData = {
      ...data,
      expirationDate: this.getExpirationDate(data),
      userId: this.getTokenPayload(data.token).userId,
    };
    this.store.commit('setSessionData', newSessionData);
    if (this.persist) {
      storageInstance.local.set('sessionData', newSessionData);
    } else {
      storageInstance.session.set('sessionData', newSessionData);
    }
  }

  public getSessionData(): SessionData {
    return this.sessionData;
  }

  public sessionExpired(): boolean {
    // Session expires 5 minutes before access token does
    return ((this.getSessionTime() - 5 * 60 * 1000) < 0);
  }

  public clearSession(): void {
    this.store.commit('clearSessionData');
    storageInstance.clearAll();
  }

  public getSessionTime(): number {
    if (!this.sessionData || !this.sessionData.token) {
      return 0;
    }
    const tokenPayload = this.getTokenPayload(this.sessionData.token);
    if (!tokenPayload || !tokenPayload.exp) {
      return 0;
    }
    return tokenPayload.exp * 1000 - Date.now();
  }

  private getExpirationDate(data: SessionData): Date {
    if (!data.token) {
      return new Date();
    }
    const tokenPayload = this.getTokenPayload(data.token);
    if (!tokenPayload || !tokenPayload.exp) {
      return new Date();
    }
    return new Date(tokenPayload.exp * 1000);
  }

  private get sessionData(): SessionData {
    return this.store.state.session;
  }

  private getTokenPayload(token: string): any {
    try {
      const payload = token.split('.')[1];
      return JSON.parse(window.atob(payload));
    } catch (error) {
      return;
    }
  }
}
